import { useState } from "react";
import {
  cityLocalities,
  conversionFactors,
  propertyTypes,
} from "../../utility/constains";

const useCircleRateCalculator = () => {
  const [city, setCity] = useState("");
  const [locality, setLocality] = useState("");
  const [propertyType, setPropertyType] = useState("");
  const [area, setArea] = useState("");
  const [unit, setUnit] = useState("Square feet");
  const [result, setResult] = useState(null);

  const handleCityChange = (event) => {
    const selectedCity = event.target.value;
    setCity(selectedCity);
    setLocality("");
  };

  const handleCalculate = () => {
    if (!city || !locality || !propertyType || !area || !unit) {
      alert("Please fill in all fields");
      return;
    }

    const areaInSqft = parseFloat(area) * conversionFactors[unit];
    const baseCircleRate = cityLocalities[city][locality];
    const percentage = propertyTypes[propertyType];
    const propertyValue = areaInSqft * baseCircleRate * percentage;

    setResult(propertyValue);
  };

  const handleReset = () => {
    setCity("");
    setLocality("");
    setPropertyType("");
    setArea("");
    setUnit("Square feet");
    setResult(null);
  };

  return {
    city,
    locality,
    propertyType,
    area,
    unit,
    result,
    handleCityChange,
    setLocality,
    setPropertyType,
    setArea,
    setUnit,
    handleCalculate,
    handleReset,
  };
};

export default useCircleRateCalculator;
